module.exports = __webpack_public_path__ + "static/media/georgia italic.d8739785.ttf";